import { Heading } from "@bps/fluent-ui";
import { Country } from "@libs/enums/country.enum.ts";
import { formDesignDomainNames } from "@libs/gateways/form-design/FormDesignGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DropdownField } from "@ui-components/form/DropdownField.tsx";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

type tenantSettingFormDropdownKeys = "demographics" | "acc" | "accDemographics";

export const tenantSettingFormDropdown: Record<
  tenantSettingFormDropdownKeys,
  { typeCode: string; domains: formDesignDomainNames[]; nzTenant?: boolean }
> = {
  demographics: {
    typeCode: "PATDEMO",
    domains: [formDesignDomainNames.practiceManagement]
  },
  acc: {
    typeCode: "ACC",
    domains: [formDesignDomainNames.acc],
    nzTenant: true
  },
  accDemographics: {
    typeCode: "ACCPATDEMO",
    domains: [
      formDesignDomainNames.practiceManagement,
      formDesignDomainNames.acc
    ],
    nzTenant: true
  }
};

export const TenantSettingsFormsDropDown: React.FC<{ formKey: string }> = ({
  formKey
}) => {
  const tenantSettingPatientLabel = {
    demographics: `${usePatientLabel(true)} details form`,
    acc: "ACC claim details form",
    accDemographics: `Combined ACC & ${usePatientLabel()} details form`
  };

  const { core, formDesign } = useStores();
  const result =
    tenantSettingFormDropdown[formKey as tenantSettingFormDropdownKeys];

  const resultPatientLabel =
    tenantSettingPatientLabel[formKey as tenantSettingFormDropdownKeys];
  if (core.tenantDetails?.country !== Country.NewZealand && result.nzTenant) {
    return null;
  }

  const validFormDesigns =
    result &&
    formDesign.formDesigns
      .filter(a => {
        const domains = a.domains?.filter(x => x !== "Forms");
        return (
          a &&
          a?.isPublished &&
          domains &&
          domains.length === result.domains.length &&
          domains.every((x: formDesignDomainNames) =>
            result.domains.includes(x)
          )
        );
      })
      .map(x => {
        return { key: x.id, text: x.name + (x.domainCode ? " (Default)" : "") };
      });

  return result ? (
    <>
      <Heading variant="section-sub-heading">{resultPatientLabel}</Heading>
      <DropdownField
        withNoEmptyOption
        name={formKey}
        styles={{ root: { width: 350 } }}
        options={validFormDesigns}
      />
    </>
  ) : null;
};
